<ng-template #shareButton>
  <button 
    style="padding: 0 30px !important;" 
    [ngClass]="{ unsharedButton: selectedShare.status === 'unshared', never_shared_share_button:selectedShare.status === 'never shared'  }" mat-button color="primary" [disabled]="processing" (click)="share()">
    <div class="button_content">
      <span class="share-text" [ngClass]="{processing: processing}">Share</span>
      <loader icon="button_wheel" *ngIf="processing"></loader>
    </div>
  </button>
</ng-template>

<top-menu></top-menu>
<mobile-menu></mobile-menu>
<loader-pane-fragment [trace]="traceNames.viewLogisticsShare"></loader-pane-fragment>
<command-menu *ngIf="!!searchTerm || (!!shareList?.length && !selectedShare)"
  [filterPage]="filterPage"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD PRODUCTION VIEW'"
  (addItem)="addShare()"
></command-menu>
<null-state 
  *ngIf="!!shareList && !shareList.length && !searchTerm && event && !event.closed"
  (buttonClick)="addShare()"
  [state]="nullState"
  [title]="nullTitle"
  [hideButton]="!event.can_access"
></null-state>
<div *ngIf="!searchTerm && (!event || event.closed)" class="closed_msg">
  This event is closed. Only active events can be shared.
</div>
<div class="no_results" *ngIf="!!searchTerm && shareList && !shareList.length">There are no production views that fit your search term.</div>
<nested-table
  *ngIf="!selectedShare && shareList.length"
  [filtersId]="filterPage"
  [items]="shareList"
  [columns]="columnData"
  [dontClearFilters]="true"
  [columnsById]="columnsById"
  [bigSecondColumn]="true"
  [readOnly]="!event || event.is_readonly"
  [menuItems]="menuItems"
  [dotMenuItems]="dotMenuItems"
  [defaultSelectedColumnId]="defaultColumnId"
  (selectItem)="openShareView($event)"
  (updatedSelectedIds)="selectIds($event)"
></nested-table>
<black-bar-wrapper 
  *ngIf="!!selectedShare && !!fullShareData?.shareData"
  (close)="closeShareView()"
><div class="header">{{ selectedShare.title || 'Unnamed Production View' }}</div>
  <div *ngIf="event?.closed" class="closed_msg">
    Closed events can't be shared.<br /><br />
    Any shareable URLs for this event have been unpublished.
  </div>
  <div class="share_wrapper" *ngIf="event && !event.closed">
    <div class="share_menu">
      <ng-container *ngIf="selectedShare.status === 'never shared' && event.can_access" [ngTemplateOutlet]="shareButton"></ng-container>
      
      <share-code 
        *ngIf="selectedShare.status !== 'never shared'" 
        [shareType]="shareTypes.logistics"
        [hideJson]="true"
        [shareCode]="selectedShare.code" 
        [emailGenerator]="emailGenerator.bind(this)"
        [disabled]="selectedShare.status !== 'shared'"
      >
        <ng-container *ngIf="selectedShare.status === 'unshared'" [ngTemplateOutlet]="shareButton"></ng-container>
      </share-code>
      <div style="flex:1;"></div>
      <div class="shared_status_holder">
        <traffic-light [color]="shareStatusToColor[selectedShare.status]" [text]="shareStatusToText[selectedShare.status]"></traffic-light>
        <div class="unpublish-link" *ngIf="selectedShare.status === 'shared' && event.can_access" (click)="unshare()">Unshare</div>
      </div>
    </div>
    <enable-links (toggle)="toggleEnableLinks()" [enabled]="!selectedShare.noURLs"></enable-links>

    <div class="desktop">
      {{ selectedShare.status === 'shared' ? SHARED_MESSAGE : UNSHARED_MESSAGE }} You can control what is visible by using the <em>Display options</em> and <em>Filter</em> buttons. <span style="font-weight: bold">Note:</span> Changes to room/locations and sessions are updated automatically.
    </div>
    <div class="filters_holder">
      <icon-text *ngIf="!!event.can_access" [active]="!!selectedShare.filters?.count" [text]="'Filter'" (click)="openFilters()"></icon-text>
      <icon-text *ngIf="!!event.can_access" [icon]="null" [text]="'Display options'" (click)="editDisplayOptions()" [active]="!!selectedShare.excludedFieldIds?.length"></icon-text>
      <div style="flex:1;"></div>
    </div>
    <scrollable-wrapper [ngClass]="{hideCal:selectedShare.status === 'never shared'}">
      <logistics-share-view *ngIf="!!fullShareData?.shareData"
        [shareData]="fullShareData.shareData"
        [brandingData]="brandingData"
        [logisticsShareable]="fullShareData.selectedShare"
      ></logistics-share-view>
    </scrollable-wrapper>
  </div>
</black-bar-wrapper>